import axios from "axios";
import DemoFileUpload from "components/orderdetail/DemoFileUpload";
import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, InputGroup, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const NeedHelpForm = ({ show, handleClose, screenshot }) => {
  const initialFormState = {
    name: "",
    subject: "",
    query: "",
    email: "",
    phone: "",
    file: null,
    screenshot: null
  };
  const [formData, setFormData] = useState(initialFormState);
  const [userData, setUserData] = useState(null);
  const [name, setName] = useState('');
  const location = useLocation();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  const handleUploadedFileChange = (files) => {
    setUploadedFiles(files);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      page_url: window.location.href,
      subject: formData.subject,
      description: formData.query,
    }
    const newFormData = new FormData();
    // newFormData.append('message', message);
    Object.keys(payload).forEach(key => {
      newFormData.append(key, payload[key]);
    });
    if (screenshot) {
      const byteCharacters = atob(screenshot.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const imageBlob = new Blob([byteArray], { type: 'image/png' });
      newFormData.append('screenshot', imageBlob, 'screenshot.png');
    }
    if (uploadedFiles.length > 0) {
      uploadedFiles.forEach(file => {
        newFormData.append("attachments", file, file.name);
      });
    }
    let tokenStr = localStorage.getItem("accessToken");
    axios.post(`${process.env.REACT_APP_SERVER_URL}/support/create`, newFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${tokenStr}`
      }
    }).then(response => {

    })
    handleClose();
  };

  useEffect(() => {
    if (show && location.state?.triggeredBy === "someAction") {
      fetchData();
    }
  }, [show, location.state])

  async function fetchData() {
    try {
      let tokenStr = localStorage.getItem("accessToken");
      const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/users/profile`, {
        headers: { 'Authorization': `Bearer ${tokenStr}` }
      });
      setUserData(data);
      setName(data.last_name + ',' + data.first_name);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  const handleCloseAndReset = () => {
    setFormData(initialFormState);
    handleClose();
  };

  return (
    (
      <Modal show={show} size="lg" onHide={handleCloseAndReset} centered>
        <Modal.Header closeButton>
          <Modal.Title>Need Help</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>

              {/* ================= LEFT SIDE ================= */}
              <Col md={6} className="border-end pe-4">
                <h6 className="mb-3 text-muted">Your Information</h6>

                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={name}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    disabled
                    value={userData?.email}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={userData?.phone}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>URL</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={window.location.href}
                  />
                </Form.Group>
              </Col>

              {/* ================= RIGHT SIDE ================= */}
              <Col md={6} className="ps-4">
                <h6 className="mb-3 text-muted">Issue Details</h6>

                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Query / Suggestion</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="query"
                    value={formData.query}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <DemoFileUpload
                    onFilesChange={handleUploadedFileChange}
                    textOfDoc="Choose File"
                    maxFiles={3}
                  />
                </Form.Group>
              </Col>

            </Row>

            {/* ================= FOOTER BUTTONS ================= */}
            <Row className="mt-4">
              <Col className="text-start">
                <Button variant="secondary" onClick={handleCloseAndReset}>
                  Cancel
                </Button>
              </Col>
              <Col className="text-end">
                <Button type="submit" variant="primary">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

      </Modal>
    )
  );
};

export default NeedHelpForm;